import { render } from "./TemplatePagination.vue?vue&type=template&id=209d70f4&scoped=true"
import script from "./TemplatePagination.vue?vue&type=script&lang=js"
export * from "./TemplatePagination.vue?vue&type=script&lang=js"

import "./TemplatePagination.vue?vue&type=style&index=0&id=209d70f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-209d70f4"]])

export default __exports__